import React from 'react';
import Icon from 'components/AppIcon';

const ServicePhilosophy = () => {
  const philosophyData = {
    title: "Nuestra Filosofía de Servicio",
    subtitle: "Our Service Philosophy",
    description: "En BAC Pool CR, creemos que cada piscina merece el mejor cuidado. Nuestra filosofía se basa en principios fundamentales que guían cada aspecto de nuestro trabajo.",
    principles: [
      {
        icon: "Leaf",
        title: "Responsabilidad Ambiental",
        titleEn: "Environmental Responsibility",
        description: `Utilizamos productos biodegradables y técnicas que minimizan el impacto ambiental. Nuestro compromiso con Costa Rica incluye la protección de sus recursos naturales.

Implementamos sistemas de dosificación precisos que reducen el desperdicio de químicos y promovemos el uso eficiente del agua en todos nuestros servicios.`,
        features: [
          "Productos biodegradables certificados",
          "Técnicas de conservación de agua",
          "Gestión responsable de residuos químicos",
          "Educación ambiental a clientes"
        ]
      },
      {
        icon: "Shield",
        title: "Seguridad Química",
        titleEn: "Chemical Safety",
        description: `La seguridad es nuestra prioridad absoluta. Todos nuestros técnicos están certificados en el manejo seguro de productos químicos y siguen protocolos estrictos de seguridad.

Utilizamos equipos de protección personal de alta calidad y mantenemos inventarios controlados de todos los productos químicos utilizados en nuestros servicios.`,
        features: [
          "Personal certificado en manejo de químicos",
          "Protocolos de seguridad estrictos",
          "Equipos de protección profesional",
          "Almacenamiento seguro de productos"
        ]
      },
      {
        icon: "Heart",
        title: "Satisfacción del Cliente",
        titleEn: "Customer Satisfaction",
        description: `Cada cliente es único y merece un servicio personalizado. Escuchamos activamente las necesidades específicas y adaptamos nuestros servicios para superar las expectativas.

Mantenemos comunicación constante con nuestros clientes y ofrecemos garantías completas en todos nuestros servicios para asegurar su total satisfacción.`,
        features: [
          "Servicios personalizados",
          "Comunicación proactiva",
          "Garantía de satisfacción 100%",
          "Soporte técnico continuo"
        ]
      }
    ]
  };

  return (
    <section className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
          {philosophyData.title}
        </h2>
        <p className="text-lg text-text-secondary font-medium mb-6">
          {philosophyData.subtitle}
        </p>
        <p className="max-w-3xl mx-auto text-text-secondary">
          {philosophyData.description}
        </p>
      </div>

      <div className="space-y-12">
        {philosophyData.principles.map((principle, index) => (
          <div key={index} className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
            {/* Content */}
            <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={principle.icon} size={24} className="text-primary" />
                </div>
                <div>
                  <h3 className="text-2xl font-heading font-bold text-text-primary">
                    {principle.title}
                  </h3>
                  <p className="text-sm text-text-secondary font-medium">
                    {principle.titleEn}
                  </p>
                </div>
              </div>

              <div className="prose prose-lg max-w-none text-text-secondary mb-6">
                <p>{principle.description}</p>
              </div>

              <div className="space-y-3">
                {principle.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center space-x-3">
                    <div className="w-6 h-6 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon name="Check" size={14} className="text-success" />
                    </div>
                    <span className="text-text-secondary">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Visual Element */}
            <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
              <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-8 text-center">
                <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Icon name={principle.icon} size={48} className="text-primary" />
                </div>
                <h4 className="text-xl font-heading font-semibold text-text-primary mb-2">
                  {principle.title}
                </h4>
                <p className="text-text-secondary">
                  Compromiso con la excelencia en cada servicio
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="mt-12 bg-primary/5 rounded-lg p-8 text-center">
        <h3 className="text-2xl font-heading font-bold text-text-primary mb-4">
          ¿Listo para experimentar nuestro servicio excepcional?
        </h3>
        <p className="text-text-secondary mb-6 max-w-2xl mx-auto">
          Únete a más de 500 clientes satisfechos que confían en BAC Pool CR para el mantenimiento de sus piscinas.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-primary/90 nav-transition">
            Solicitar Cotización
          </button>
          <button className="border border-primary text-primary px-6 py-3 rounded-lg font-medium hover:bg-primary/5 nav-transition">
            Conocer Servicios
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicePhilosophy;